
/**
 * Pertence ao CD
 */
export class RegiaoCentroDistribuicaoApi {
    async list(filters = null) {
        try {
            const response = await axios.get(`/adm/centros-distribuicao/regioes/list`, {
                params: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching regions cd:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            const response = await axios.get(`/adm/centros-distribuicao/regioes/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching region cd:', error);
            throw error;
        }
    }
    
    async store(data) {
        try {
            const response = await axios.post('/adm/centros-distribuicao/regioes', data);

            return response.data;
        } catch (error) {
            console.error('Error store region cd:', error);
            throw error;
        }
    }

    async update(data, id) {
        try {
            const response = await axios.put(`/adm/centros-distribuicao/regioes/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error update region cd:', error);
            throw error;
        }
    }
    async destroy(id) {
        try {
            const response = await axios.delete(`/adm/centros-distribuicao/regioes/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error delete region cd:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/RegiaoCentroDistribuicaoApi.js